export const metricKey = (metric) =>
  `${metric.metricId}_${metric.entityId}_${metric.entityType}_${metric.unit}`;

export const containsMetric = (arr, metric) => {
  return !!arr.find((it) => {
    return metricKey(it) === metricKey(metric);
  });
};

export const removeMetric = (arr, metric) => {
  return arr.filter((it) => {
    return metricKey(it) !== metricKey(metric);
  });
};

export const longName = (metric) => {
  return metric.values.join(" - ");
};

export const isMultiDeviceMetric = (metric) =>
  metric.isDevice && (metric.entityType !== "Device" || metric.entityId === -1);
